import { useCallback, useContext } from "react";
import { SignalRContext } from "../context/SignlaRContext";

export const useSignalRConnection = () => {
  const connection = useContext(SignalRContext);

  const events = useCallback(
    (
      onMessageReceived: (
        eventType: string,
        data: any,
        examInstanceId?: string
      ) => void
    ) => {
      if (connection) {
        const handleReceiveMessage = (username: string, message: string) => {
          console.log("ReceiveMessage", username, message);
          onMessageReceived("status", message);
        };

        const handleReceiveTimeForMonitoring = (
          percentage: string,
          examInstanceId: string
        ) => {
          console.log("RecieveTimeForMonitoring", percentage, examInstanceId);
          onMessageReceived("monitorTime", percentage, examInstanceId);
        };

        const handleRefreshPercentageResponseForMonitoring = (
          examInstanceId: string
        ) => {
          getPercetageForMonitoring(examInstanceId);
          onMessageReceived("refreshPercentage", "", examInstanceId);
        };

        const handleReceivePercentageForMonitoring = (
          percentage: string,
          examInstanceId: string
        ) => {
          onMessageReceived("percentage", percentage, examInstanceId);
        };

        connection.on("ReceiveMessage", handleReceiveMessage);
        connection.on(
          "RecieveTimeForMonitoring",
          handleReceiveTimeForMonitoring
        );
        connection.on(
          "RefreshPercentageResponseForMonitoring",
          handleRefreshPercentageResponseForMonitoring
        );
        connection.on(
          "RecievePercentageForMonitoring",
          handleReceivePercentageForMonitoring
        );

        return () => {
          connection.off("ReceiveMessage", handleReceiveMessage);
          connection.off(
            "RecieveTimeForMonitoring",
            handleReceiveTimeForMonitoring
          );
          connection.off(
            "RefreshPercentageResponseForMonitoring",
            handleRefreshPercentageResponseForMonitoring
          );
          connection.off(
            "RecievePercentageForMonitoring",
            handleReceivePercentageForMonitoring
          );
        };
      }
      return () => {};
    },
    [connection]
  );

  const newMessage = (messages: string) => {
    if (connection) {
      connection
        .send("SendMessage", "status", messages);
    }
  };

  const getTime = () => {
    if (connection) {
      connection.send("GetTime");
    }
  };

  const getTimeForMonitoring = (examInstanceId: string) => {
    console.log(examInstanceId);

    if (connection) {
      connection
        .send("GetTimeForMonitoring", examInstanceId);
    }
  };

  const getPercetageForMonitoring = (examInstanceId: string) => {
    if (connection) {
      connection
        .send("GetPercentageForMonitoring", examInstanceId);
    }
  };

  const sendPauseSingleParticipantsExamInstance = (
    userId: string,
    message: string
  ) => {
    if (connection) {
      connection.send(
        "SendPauseSingleParticipantsExamInstance",
        userId,
        message
      );
    }
  };

  const sendContinueSingle = (userId: string, message: string) => {
    if (connection) {
      connection.send(
        "SendContinueSingleParticipantsExamInstance",
        userId,
        message
      );
    }
  };

  const sendDisqualifySingle = (userId: string, message: string) => {
    if (connection) {
      connection.send(
        "SendDisqualifySingleParticipantsExamInstance",
        userId,
        message
      );
    }
  }

  const sendNoShowSingle = (userId: string, message: string) => {
    if (connection) {
      connection.send(
        "SendNoShowSingleParticipantsExamInstance",
        userId,
        message
      );
    }
  }

  const sendCheckoutSingle = (userId: string, message: string) => {
    if (connection) {
      connection.send(
        "SendCheckOutSingleParticipantsExamInstance",
        userId,
        message
      );
    }
  }

  const sendRegisterSingle = (userId: string, message: string) => {
    if (connection) {
      connection.send(
        "SendRegisterSingleParticipantsExamInstance",
        userId,
        message
      );
    }
  }

  return {
    events,
    newMessage,
    getTime,
    getTimeForMonitoring,
    sendPauseSingleParticipantsExamInstance,
    sendContinueSingle,
    sendDisqualifySingle,
    sendNoShowSingle,
    sendCheckoutSingle,
    sendRegisterSingle,
  };
};
